import { render, staticRenderFns } from "./AddSaleTable.vue?vue&type=template&id=624bebd6&"
import script from "./AddSaleTable.js?vue&type=script&lang=js&"
export * from "./AddSaleTable.js?vue&type=script&lang=js&"
import style0 from "./AddSaleTable.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports